<template>
  <form @submit.prevent="submit()">
    <b-row>
      <b-col>
        <b-row>
          <b-col class="pt-3" cols="12" lg="6">
            <div :class="['form-group', isInvalid('title') ? 'has-danger' : '']">
              <label
                      for="excmtasktype_title"
                      class="form-control-label">{{$t('views.excmtasktype.form.title')}}:</label>
              <input
                      id="excmtasktype_title"
                      v-model="item.title"
                      :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                      type="text"
                      required="true"
                      placeholder=""
                      @input="handleUpdateField('title', $event.target.value)">
              <div
                      v-if="isInvalid('title')"
                      class="invalid-feedback">{{ violations.title }}</div>
            </div>
          </b-col>
          <b-col class="pt-3" cols="12" lg="6">
            <div :class="['form-group', isInvalid('subtitle') ? 'has-danger' : '']">
              <label
                      for="excmtasktype_subtitle"
                      class="form-control-label">{{$t('views.excmtasktype.form.subtitle')}}:</label>
              <input
                      id="excmtasktype_subtitle"
                      v-model="item.subtitle"
                      :class="['form-control', isInvalid('subtitle') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('subtitle', $event.target.value)">
              <div
                      v-if="isInvalid('subtitle')"
                      class="invalid-feedback">{{ violations.subtitle }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="3">
            <div :class="['form-group', isInvalid('cost') ? 'has-danger' : '']">
              <label
                      for="excmtasktype_cost"
                      class="form-control-label">{{$t('views.excmtasktype.form.cost')}}:</label>
              <input
                      id="excmtasktype_cost"
                      v-model="item.cost"
                      :class="['form-control', isInvalid('cost') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('cost', $event.target.value)">
              <div
                      v-if="isInvalid('cost')"
                      class="invalid-feedback">{{ violations.cost }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="3">
            <div :class="['form-group', isInvalid('desc2tooltip') ? 'has-danger' : '']">
              <label
                      for="excmtasktype_desc2tooltip"
                      class="form-control-label">{{$t('views.excmtasktype.form.desc2tooltip')}}:</label>
              <input
                      id="excmtasktype_desc2tooltip"
                      v-model="item.desc2tooltip"
                      :class="['form-control', isInvalid('desc2tooltip') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('desc2tooltip', $event.target.value)">
              <div
                      v-if="isInvalid('desc2tooltip')"
                      class="invalid-feedback">{{ violations.desc2tooltip }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="3">
            <div :class="['form-group', isInvalid('duration') ? 'has-danger' : '']">
              <label
                      for="excmtasktype_duration"
                      class="form-control-label">{{$t('views.excmtasktype.form.duration')}}:</label>
              <input
                      id="excmtasktype_duration"
                      v-model="item.duration"
                      :class="['form-control', isInvalid('duration') ? 'is-invalid' : '']"
                      type="number"
                      placeholder=""
                      @input="handleUpdateField('duration', $event.target.value)">
              <div
                      v-if="isInvalid('duration')"
                      class="invalid-feedback">{{ violations.duration }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="3">
            <div :class="['form-group', isInvalid('durationUnit') ? 'has-danger' : '']">
              <label
                for="excmtasktype_durationUnit"
                class="form-control-label">{{$t('views.excmtasktype.form.durationUnit')}}:</label>
              <fg-input :error="violations.durationUnit">
                <el-select
                  id="excmtasktype_durationUnit"
                  :class="['select-default', isInvalid('durationUnit') ? 'select-danger' : '']"
                  filterable
                  v-model="item.durationUnit">
                  <el-option v-for="option in timeUnits"
                             class="select-default"
                             :value="option.value"
                             :label="option.text"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </b-col>
        </b-row>
        <taskDeadlineExceededOptions
          :item="item"
          v-if="taskTypeOptions.length > 0 && !isLoadingTaskTypes"
          :handle-update-field="handleUpdateField"
          :is-invalid="isInvalid"
          :violations="violations"
        />
        <b-row>
          <b-col cols="12" lg="3">
            <div :class="['form-group', isInvalid('defaultTask') ? 'has-danger' : '']">
              <label
                for="excmtasktype_defaultNextTask"
                class="form-control-label">{{$t('views.excmtasktype.form.defaultNextTask')}}:</label>
              <fg-input :error="violations.idPriority">
                <el-select
                  id="excmtasktype_defaultNextTask"
                  :class="['select-default', isInvalid('defaultTask') ? 'select-danger' : '']"
                  filterable
                  v-model="item.idDefaultNextTask">
                  <el-option v-for="option in taskTypeOptions"
                             class="select-default"
                             :value="option['value']"
                             :label="option['text'] + (option.idCasesType ? ' (' + option.idCasesType.title + ')' : '')"
                             :key="option['value']">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </b-col>
          <b-col cols="6" lg="3">
            <div :class="['form-group', isInvalid('idCaseType') ? 'has-danger' : '']">
              <label
                for="excmtasktypeCaseType"
                class="form-control-label">{{$t('views.excmtasktype.form.idCasesType')}}:</label>
              <fg-input :error="violations.idCasesType">
                <el-select
                  id="excmtasktypeCaseType"
                  :class="['select-default', isInvalid('idCasesType') ? 'select-danger' : '']"
                  filterable
                  v-model="item.idCasesType">
                  <el-option v-for="option in caseTypeOptions"
                             class="select-default"
                             :value="option['value']"
                             :label="option['text']"
                             :key="option['value']">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </b-col>
          <b-col cols="6" lg="3">
            <div :class="['form-group', isInvalid('defaultTask') ? 'has-danger' : '']">
              <label
                for="excmtasktypeTeam"
                class="form-control-label">{{$t('routes.EXCMTeamShow')}}:</label>
              <fg-input :error="violations.idTeam">
                <el-select
                  id="excmtasktypeTeam"
                  :class="['select-default', isInvalid('defaultTask') ? 'select-danger' : '']"
                  filterable
                  v-model="item.idTeam">
                  <el-option v-for="option in teams"
                             class="select-default"
                             :value="option['@id']"
                             :label="option['name']"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </b-col>
          <b-col cols="6" lg="3">
            <label
              for="color"
              class="form-control-label">{{$t('views.excmtasktype.form.color')}}:</label><br>
            <el-color-picker v-model="item.color"></el-color-picker>
            <div
              v-if="isInvalid('color')"
              class="invalid-feedback">{{ violations.color }}</div>
          </b-col>
        </b-row>
        <b-row v-if="item.taskParams">
          <b-col sm="6" lg="2">
            <label
              for="canBeDailyPlanItem"
              class="form-control-label">{{$t('views.excmtasktype.form.canBeDailyPlanItem')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="canBeDailyPlanItem" button-variant="outline-primary" v-model="item.taskParams.canBeDailyPlanItem" name="enableNotes">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="4">
            <label
              for="auto-dispatch"
              class="form-control-label">{{$t('views.excmtasktype.form.autoDispatch')}}:</label>
            <b-form-group>
              <b-form-radio-group stacked id="auto-dispatch" button-variant="outline-primary" v-model="item.taskParams.autoDispatch" name="autoDispatch">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('views.excmtasktype.form.poolTaskRecipientDuringCreatingOptions.returned')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('views.excmtasktype.form.poolTaskRecipientDuringCreatingOptions.currentUserData')}}</b-form-radio>
                <b-form-radio :value="2" variant="info" class="mt-0">{{$t('views.excmtasktype.form.poolTaskRecipientDuringCreatingOptions.previousPoolTask')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="2">
            <label
              for="auto-start-after-take"
              class="form-control-label">{{$t('views.excmtasktype.form.autoStartAfterTake')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="auto-start-after-take" button-variant="outline-primary" v-model="item.taskParams.autoStartAfterTake" name="enableNotes">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="2">
            <label
              for="auto-start-after-take"
              class="form-control-label">{{$t('views.excmtasktype.form.autoCloseCase')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="auto-dispatch" button-variant="outline-primary" v-model="item.taskParams.autoCloseCase" name="enableNotes">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="1">
            <label
              for="auto-start-after-take"
              class="form-control-label">{{$t('views.excmtasktype.form.canHaveDocument')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="auto-dispatch" button-variant="outline-primary" v-model="item.taskParams.canHaveDocument" name="enableNotes">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="2">
            <label
              for="creating-task-will-ask-customer-in-ticket"
              class="form-control-label">{{$t('views.excmtasktype.form.creatingTaskWillAskCustomerInTicket')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="auto-dispatch" button-variant="outline-primary" v-model="item.taskParams.creatingTaskWillAskCustomerInTicket" name="enableNotes">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col sm="6" lg="2">
            <label
              for="cannotBeConcurrent"
              class="form-control-label">{{$t('views.excmtasktype.form.cannotBeConcurrent')}}:</label>
            <b-form-group>
              <b-form-radio-group buttons id="auto-dispatch" button-variant="outline-primary" v-model="item.taskParams.cannotBeConcurrent" name="cannotBeConcurrent">
                <b-form-radio :value="false" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
                <b-form-radio :value="true" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="item.customFields.length > 0" class="mt-3">
      <b-col>
        <b-row>
          <b-col>
            <h6>{{ $t('views.excmcasetype.form.customFields') }}:</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr class="mt-1 mb-1">
          </b-col>
        </b-row>
        <b-row v-for="(customField, index) in item.customFields" v-bind:key="'customField-' + index">
          <b-col>
            <CustomField :item="customField" :index="index" :violations="violations" :items="item.customFields"></CustomField>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn class="btn btn-success" @click="addNewField()">{{ $t('views.excmcasetype.form.addNewField') }}</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button
                type="submit"
                class="btn btn-success">{{$t('buttons.submit')}}</button>
      </b-col>
    </b-row>
    <CustomFieldAddModal :violations="violations" :fieldTypes="fieldTypes" :handleUpdateField="handleUpdateField"></CustomFieldAddModal>
    <CustomFieldEditModal :violations="violations" :fieldTypes="fieldTypes" :handleUpdateField="handleUpdateField"></CustomFieldEditModal>
    <CustomFieldValueAddModal :violations="violations" :handleUpdateField="handleUpdateField"></CustomFieldValueAddModal>
    <CustomFieldValueEditModal :violations="violations" :handleUpdateField="handleUpdateField"></CustomFieldValueEditModal>
  </form>
</template>

<script>
import CustomField from '../excmcasetype/components/CustomFieldValue/CustomField'
import CustomFieldAddModal from '../excmcasetype/components/CustomFieldValue/modal/CustomFieldAddModal'
import CustomFieldEditModal from '../excmcasetype/components/CustomFieldValue/modal/CustomFieldEditModal'
import CustomFieldValueAddModal from '../excmcasetype/components/CustomFieldValue/modal/CustomFieldValueAddModal'
import CustomFieldValueEditModal from '../excmcasetype/components/CustomFieldValue/modal/CustomFieldValueEditModal'
import ApiService from '@/utils/ApiService'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import TaskDeadlineExceededOptions from '@/components/Dashboard/Views/excmtasktype/TaskDeadlineExceededOptions.vue'

export default {
  components: {
    TaskDeadlineExceededOptions,
    CustomField,
    CustomFieldAddModal,
    CustomFieldEditModal,
    CustomFieldValueAddModal,
    CustomFieldValueEditModal
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      teams: [],
      fieldTypes: [
        {
          name: this.$t('fieldTypes.input'),
          value: 'input'
        },
        {
          name: this.$t('fieldTypes.select'),
          value: 'select'
        },
        {
          name: this.$t('fieldTypes.datetime'),
          value: 'datetime'
        },
        {
          name: this.$t('fieldTypes.multiSelect'),
          value: 'multiSelect'
        },
        {
          name: this.$t('fieldTypes.inputFormatted'),
          value: 'inputFormatted'
        },
        {
          name: this.$t('fieldTypes.itemsCollection'),
          value: 'itemsCollection'
        },
        {
          name: this.$t('fieldTypes.idUserData'),
          value: 'idUserData'
        }
      ],
      timeUnits: [
        { value: 1, text: this.$t('global.timeMeasures.minutes') },
        { value: 2, text: this.$t('global.timeMeasures.hours') },
        { value: 3, text: this.$t('global.timeMeasures.days') },
        { value: 4, text: this.$t('global.timeMeasures.workDays') },
        { value: 5, text: this.$t('global.timeMeasures.workHours') }
      ]
    }
  },

  computed: {
    ...mapGetters({
      taskTypeOptions: 'excmtasktype/list/getTaskTypeOptions',
      caseTypeOptions: 'excmnotificationmessage/list/caseTypeOptions',
      isLoadingTaskTypes: 'excmtasktype/list/isLoading'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },
    customFieldObject () {
      return this.$store.state.modals.customField.create.customFieldObject
    },
    customFieldObjectUpdated () {
      return this.$store.state.modals.customField.update.customFieldObjectUpdated
    },
    indexUpdated () {
      return this.$store.state.modals.customField.update.indexUpdated
    }
  },

  watch: {
    customFieldObject: function (field) {
      if (Object.entries(field).length > 0) {
        this.item.customFields.push(field)
        this.$store.state.modals.customField.create.customFieldObject = {}
      }
    },
    customFieldObjectUpdated: function (val) {
      this.handleUpdatedCustomField()
    },
    indexUpdated: function (val) {
      this.handleUpdatedCustomField()
    },
    'item.cost': function () {
      this.item.cost = this.item.cost.replace(/[^0-9.]/g, '')
    }
  },
  created () {
    this.getTaskTypes()
    this.fetchCaseTypeOptions()
    this.getTeams()
    if (this.initialValues) {
      this.handleInitialValues()
    }
  },
  methods: {
    ...mapActions({
      fetchTaskTypes: 'excmtasktype/list/getItems',
      fetchCaseTypeOptions: 'excmnotificationmessage/list/fetchCaseTypeOptions'
    }),
    handleInitialValues () {
      this.initialValues.cost = this.initialValues.cost.toString()
      if (this.initialValues.idDefaultNextTask) {
        this.initialValues.idDefaultNextTask = this.initialValues.idDefaultNextTask['@id']
      }
    },
    async getTeams () {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_c_m_teams', params).getResults()
      this.teams = response.items
    },
    getTaskTypes () {
      let link = addParamsToQuery('e_x_c_m_task_types', {
        pagination: false
      })
      this.fetchTaskTypes(link)
    },
    getCaseTypes () {
      let link = addParamsToQuery('e_x_c_m_case_types', {
        pagination: false
      })
      this.fetchCaseTypes(link)
    },
    handleUpdatedCustomField () {
      if (Object.entries(this.customFieldObjectUpdated).length > 0 && this.indexUpdated > -1) {
        this.item.customFields.splice(this.indexUpdated, 1, this.customFieldObjectUpdated)
        this.$store.state.modals.customField.update.indexUpdated = -1
        this.$store.state.modals.customField.update.customFieldObjectUpdated = {}
      }
    },
    addNewField () {
      this.$store.state.modals.customField.create.show = 1
      this.$store.state.modals.customField.create.parent = this.item
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    submit () {
      if (typeof this.item.duration === 'string') this.item.duration = parseInt(this.item.duration)
      if (typeof this.item.durationUnit === 'string') this.item.durationUnit = parseInt(this.item.durationUnit)
      if (typeof this.item.notification === 'string') this.item.notification = parseInt(this.item.notification)
      if (typeof this.item.notificationEnable === 'string') this.item.notificationEnable = parseInt(this.item.notificationEnable)
      if (typeof this.item.alarm === 'string') this.item.alarm = parseInt(this.item.alarm)
      if (typeof this.item.alarmEnable === 'string') this.item.alarmEnable = parseInt(this.item.alarmEnable)
      if (typeof this.item.alarmNotFinishedEnable === 'string') this.item.alarmNotFinishedEnable = parseInt(this.item.alarmNotFinishedEnable)
      if (typeof this.item.daysToCreateTaskAfterDeadlineExceeded === 'string') this.item.daysToCreateTaskAfterDeadlineExceeded = parseInt(this.item.daysToCreateTaskAfterDeadlineExceeded)
      this.handleSubmit(this.item)
    }
  }
}
</script>
